import ReactHabitat from 'react-habitat'
import {ReduxDomFactory} from 'react-habitat-redux';
import configureStore from './redux/index';
import 'babel-polyfill'
// components
import CarousselMoodboard from './components/CarousselMoodboard'
import CarousselLauncher from './components/CarousselLauncher'
import FixedBlock from './components/FixedBlock'
import IGNMap from './components/IgnMap'
import DestinationsMap from './components/DestinationsMap'
import ProgressionBar from './components/ProgressionBar'
import NewsletterPush from './components/NewsletterPush'
import ScrollDown from './components/ScrollDown'
import StickyRight from './components/StickyRight'
import Pagination from './components/Pagination'
import PaginationBundled from './components/PaginationBundled'
import CssPaginator from './components/CssPaginator'
import TagManager from './utils/tagManager'
import LazyLoadComponent from './components/LazyLoadComponent'
import AdsContainer from './components/AdsContainer'

import {
    AddThis,
    Analytics,
    Caroussel,
    CookiesBanner,
    FormCovid19,
    CirkwiFilters,
    HeaderMenu,
    MoreLess,
    Player as PlayerBlock,
    RangePicker,
    Select,
    HomePartners,
    SwitchLanguage,
    InlineArticlePush,
    OverlayPush
} from './../../../../vendor/bbs/crt/src/resources/js/kernel'


// views

import objectFitImages from './utils/ObjectFitImages';

//
// React
//

class MyApp extends ReactHabitat.Bootstrapper {
    constructor() {
        super();

        // Create a new container builder
        let store = configureStore();
        var container = new ReactHabitat.ContainerBuilder()
        container.factory = new ReduxDomFactory(store);

        container.register(FormCovid19).as('FormCovid19')
        container.register(HeaderMenu).as('HeaderMenu')
        container.register(IGNMap).as('IGNMap')
        container.register(MoreLess).as('MoreLess')
        container.register(DestinationsMap).as('DestinationsMap')
        container.register(FixedBlock).as('FixedBlock')
        container.register(ProgressionBar).as('ProgressionBar')
        container.register(Caroussel).as('Caroussel')
        container.register(CarousselLauncher).as('CarousselLauncher')
        container.register(CarousselMoodboard).as('CarousselMoodboard')
        container.register(CirkwiFilters).as('CirkwiFilters')
        container.register(PlayerBlock).as('PlayerBlock')
        container.register(Pagination).as('Pagination')
        container.register(PaginationBundled).as('PaginationBundled')
        container.register(RangePicker).as('RangePicker')
        container.register(NewsletterPush).as('NewsletterPush')
        container.register(ScrollDown).as('ScrollDown')
        container.register(CssPaginator).as('CssPaginator')
        container.register(StickyRight).as('StickyRight')
        container.register(Select).as('Select')
        container.register(Analytics).as('Analytics')
        container.register(CookiesBanner).as('CookiesBanner')
        container.register(AddThis).as('AddThis')
        container.register(HomePartners).as('HomePartners')
        container.register(SwitchLanguage).as('SwitchLanguage')
        container.register(InlineArticlePush).as('InlineArticlePush')
        container.register(OverlayPush).as('OverlayPush')
        container.register(LazyLoadComponent).as('LazyLoadComponent')
        container.register(AdsContainer).as('AdsContainer')

        // Finally, set the container
        this.setContainer(container.build())

        objectFitImages();

        TagManager.initAddthis();
    }
}

// Always export a 'new' instance so it immediately evokes
export default new MyApp();



// WEBPACK FOOTER //
// ./resources/assets/frontend/js/main.js